import {config} from '../../utils.js';
const EVENT_COMMENT_OWN_PRODUCT = 'event-comment-own-product';
const commentOwnProductEventTrigger = () => {
  if(!config.user) {
    return;
  }
  document.querySelectorAll('.add-comment-grid-form, .js-comment-product')
      .forEach(form => form.addEventListener('submit', () => {
        const currentUser = config.user.id;
        const productJson = form.closest('[data-product-id], [data-id-product]')
            .querySelector('.js-product-data');
        const productData = JSON.parse(productJson.textContent);
        if (currentUser == productData.owner) {
          const event = new CustomEvent(EVENT_COMMENT_OWN_PRODUCT);
          document.dispatchEvent(event);
        }
      })
  );
};

export {EVENT_COMMENT_OWN_PRODUCT, commentOwnProductEventTrigger};